<template>
  <div>
    <div
      class="picture-container"
      @click="openProfilePictureModal"
    >
      <div
        class="profile-picture"
        :style="`background-image: url(${user.picture || './static/profile/profile.svg'});`"
      >
      </div>
    </div>
    <profile-picture-modal ref="profilePictureModal" />
  </div>
</template>
<script>

import ProfilePictureModal from '@/components/settings/tabs/change_profile_picture/ProfilePictureModal';

export default {
  name: 'ChangeProfilePictureContent',
  components: {
    ProfilePictureModal,
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    openProfilePictureModal() {
      this.$refs.profilePictureModal.$refs.modal.show();
    },
  },
};
</script>

<style scoped>
.picture-container {
  background-color: white;
  border: 1px solid #dddddd;
  border-radius: 87.5px;
  margin: 25px auto 10px auto;
  max-height: 175px !important;
  min-height: 175px !important;
  max-width: 175px !important;
  min-width: 175px !important;
  cursor: pointer;
}

.profile-picture {
  background-color: #eeeeee;
  border-radius: 78px;
  margin: 9px 9px;
  max-height: 156px !important;
  min-height: 156px !important;
  max-width: 156px !important;
  min-width: 156px !important;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/tabs/change_profile_picture/ChangeProfilePictureContent.vue